export function redirectIndex() {
    sessionStorage.clear();
    window.location.href = "/";
}
